<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="layout-aside">
      <div class="logo" :class="{ 'logo--collapse': isCollapse }">
        <img v-if="!isCollapse" class="logo-img" src="/images/wecare-logo.png" alt="WeCare" />
        <span v-if="!isCollapse">WeCare</span>
        <img v-else class="logo-img logo-img--small" src="/images/wecare-logo.png" alt="WeCare" />
      </div>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :router="true"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        class="sidebar-menu"
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">{{ $t('layout.menuDashboard') }}</span>
        </el-menu-item>
        <el-menu-item index="/admin-users">
          <i class="el-icon-user"></i>
          <span slot="title">{{ $t('layout.menuAdmin') }}</span>
        </el-menu-item>
        <el-menu-item index="/user-data">
          <i class="el-icon-s-custom"></i>
          <span slot="title">{{ $t('layout.menuUserData') }}</span>
        </el-menu-item>
        <!-- 登录链接发送记录：运营审计「链接发了没有、对方看没看到」 -->
        <el-menu-item index="/login-link-logs">
          <i class="el-icon-message"></i>
          <span slot="title">{{ $t('layout.menuLoginLinkLogs') }}</span>
        </el-menu-item>
        <el-menu-item index="/user-batch">
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">{{ $t('layout.menuUserBatch') }}</span>
        </el-menu-item>
        <el-menu-item index="/user-group">
          <i class="el-icon-s-grid"></i>
          <span slot="title">{{ $t('layout.menuUserGroup') }}</span>
        </el-menu-item>
        <el-menu-item index="/user-prompts">
          <i class="el-icon-chat-line-square"></i>
          <span slot="title">{{ $t('layout.menuUserPrompts') }}</span>
        </el-menu-item>
        <el-menu-item index="/contents">
          <i class="el-icon-document"></i>
          <span slot="title">{{ $t('layout.menuContents') }}</span>
        </el-menu-item>
        <el-menu-item index="/materials">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">{{ $t('layout.menuMaterials') }}</span>
        </el-menu-item>
        <el-menu-item index="/pushes">
          <i class="el-icon-s-promotion"></i>
          <span slot="title">{{ $t('layout.menuPushes') }}</span>
        </el-menu-item>
        <el-menu-item index="/analytics">
          <i class="el-icon-s-data"></i>
          <span slot="title">{{ $t('layout.menuAnalytics') }}</span>
        </el-menu-item>
        <el-menu-item index="/auto-push">
          <i class="el-icon-time"></i>
          <span slot="title">{{ $t('layout.menuAutoPush') }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部导航 -->
      <el-header class="layout-header">
        <div class="header-left">
          <i
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="isCollapse = !isCollapse"
          ></i>
          <span class="header-title">{{ $t('layout.title') }}</span>
        </div>
        <div class="header-right">
          <el-select
            :value="$getLang()"
            size="mini"
            style="width: 100px; margin-right: 16px"
            @change="$setLang"
          >
            <el-option label="中文" value="zh" />
            <el-option label="English" value="en" />
          </el-select>
          <span class="admin-name">{{ adminName }}</span>
          <el-button type="text" @click="handleLogout">{{ $t('layout.logout') }}</el-button>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main class="layout-main">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    // 当前激活的菜单
    activeMenu() {
      const path = this.$route.path
      // 处理子路由高亮
      if (path.startsWith('/user-data/')) return '/user-data'
      if (path.startsWith('/user-batch/edit')) return '/user-batch'
      if (path.startsWith('/user-group/edit')) return '/user-group'
      if (path.startsWith('/contents/edit')) return '/contents'
      if (path.startsWith('/materials/edit')) return '/materials'
      if (path.startsWith('/auto-push/')) return '/auto-push'
      return path
    },
    // 管理员名称
    adminName() {
      const userInfo = this.$store.state.userInfo
      return userInfo ? (userInfo.name || userInfo.email || this.$t('layout.adminDefault')) : this.$t('layout.adminDefault')
    }
  },
  methods: {
    // 退出登录
    async handleLogout() {
      try {
        await this.$confirm(this.$t('layout.logoutConfirm'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
        await this.$store.dispatch('logout')
        this.$router.push('/login')
        this.$message.success(this.$t('layout.logoutSuccess'))
      } catch (e) {
        // 取消退出
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.layout-aside {
  background-color: #304156;
  transition: width 0.3s;
  overflow: hidden;
}
.logo {
  height: 60px;
  text-align: left;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  background-color: #263445;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-left: 20px;
}
.logo--collapse {
  justify-content: center;
  padding-left: 0;
}
.logo-img {
  height: 38px;
  width: auto;
  object-fit: contain;
}
.logo-img--small {
  height: 32px;
}
.sidebar-menu {
  border-right: none;
}
.sidebar-menu:not(.el-menu--collapse) {
  width: 220px;
}
.layout-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 20px;
  z-index: 1;
}
.header-left {
  display: flex;
  align-items: center;
}
.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  margin-right: 15px;
  color: #606266;
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.header-right {
  display: flex;
  align-items: center;
}
.admin-name {
  margin-right: 15px;
  color: #606266;
  font-size: 14px;
}
.layout-main {
  background: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
/* 页面切换动画 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s;
}
.fade-transform-enter,
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
